"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mod = exports.PHI = exports.PI2 = exports.log = void 0;
/**
 * Return logarith value and base
 *
 * @category Utilities
 *
 * @param n number
 * @param base number
 */
const log = (n, base) => Math.log(n) / Math.log(base);
exports.log = log;
/**
 * @category Utilities
 */
exports.PI2 = Math.PI * 2;
/**
 * @category Utilities
 */
exports.PHI = (1 + Math.sqrt(5)) / 2;
/**
 * Return a positive module of positive or negative value
 *
 * @category Utilities
 *
 * @param value number
 * @param base number
 */
const mod = (value, base) => {
    const result = value % base;
    return result < 0 ? result + base : result;
};
exports.mod = mod;
//# sourceMappingURL=index.js.map